export default __webpack_public_path__ + "static/media/4.f8e230c2.png";